import {
    ADSLIDER_LIST_ATTEMPT,
    ADSLIDER_LIST_SUCCESS,
    ADSLIDER_LIST_FAILED,
} from "../types/adSliderTypes";

const INITIAL_STATE = {
    loading: true,
    list: [],
    error: ""
};
function adSlider(state = INITIAL_STATE, action) {
    switch (action.type) {
        case ADSLIDER_LIST_ATTEMPT:
            return {
                ...state,
                loading: true
            };

        case ADSLIDER_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                list: action.data.list,
                error: ""
            };

        case ADSLIDER_LIST_FAILED:
            return {
                ...state,
                loading: false,
                error: action.error,
                list: []
            };

        default:
            return state;
    }
}
export default adSlider;